import {
	Component,
	OnInit,
	Input,
	EventEmitter,
	Output,
	ViewChild,
	Renderer
} from '@angular/core';
import { NgOption } from '@ng-select/ng-select';

@Component({
	selector: 'inline-edit-select',
	templateUrl: './inline-edit-select.component.html',
	styleUrls: ['./inline-edit-select.component.scss']
})

export class InlineEditSelectComponent implements OnInit {
	public value: any;
	public selectedOptionValue: any;
	public isEditView: boolean = false;
	public docEditUnlisten: any;
	@Input() name: string;
	@Input() elementFor: string;
	@Input() txtField: string;
	@Input() selectedValue: string;
	@Input() isRequired: boolean;
	@Input() options: NgOption[];
	@Input() permission: string;
	@Output() updateValue: EventEmitter<any> = new EventEmitter();
	
	@ViewChild('container', { static: true }) container;

	constructor(private renderer: Renderer) { }

	ngOnInit() {}

	getValue(options) {
		if (this.options != undefined && this.selectedValue) {
			let selectedLabel = this.options.find(x => x.value == this.selectedValue);
			if (selectedLabel != undefined) {
				return selectedLabel.label;
			} else {
				return this.selectedValue;
			}
		}
	}

	showEditable() {
		this.value = this.selectedValue;
		this.isEditView = true;
		this.docEditUnlisten = this.renderer.listenGlobal('document', 'click', (event) => {
			if (!this.container.nativeElement.contains(event.target)) {
				this.showDetail();
			}
		})
	}

	save() {
		this.updateValue.emit(this.value);
	}

	showDetail() {
		this.isEditView = false;
	}

	select(event, select_component) {
		select_component.isValueSelected = true;
		return;
	}
}
